// Link.jsx
import React from "react";

function navigateTo(url) {
  window.history.pushState({}, "", url);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export default function Link({ href, children, ...props }) {
  function handleClick(e) {
    // Left click without modifiers → SPA navigation
    if (e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      navigateTo(href);
    }
    // Otherwise let the browser handle it (right/middle click, ctrl+click, etc.)
  }

  return (
    <a href={href} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}



// WEBPACK FOOTER //
// ./src/react-component/Link.jsx